export var cibCevo = ["32 32", "<path d='M4.667 8h16l8 13.734 3.333-5.734-8-13.865h-16zM3.469 10l-3.469 6 8 13.865h16l3.469-6-3.333-5.729-3.469 6h-9.333l-4.667-8.135 3.469-6z'/>"];
